import script from "./payment-run-step-two.vue?vue&type=script&lang=ts&setup=true"
export * from "./payment-run-step-two.vue?vue&type=script&lang=ts&setup=true"

import "./payment-run-step-two.vue?vue&type=style&index=0&id=a124b906&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a124b906"]])

export default __exports__